import React from "react";
import "../../src/styles/Blogs/BlogDetails/BlogDetails.scss";
import { Container } from "react-bootstrap";
import { AiOutlineEye } from "react-icons/ai";
import { BiTimeFive } from "react-icons/bi";
import articlesPersonImage from "../assets/images/articles-person-image.png";
import blogDetailsBannerImage from "../assets/images/blogDetailsBannerImage.png";
const BlogDetails = () => {
  return (
    <Container fluid>
      <Container>
        <h6 className="blog-details-category title">Grid System</h6>
        <h2 className="blog-details-title">
          The Grid System: Importance of a Solid UX/UI Layout
        </h2>
        <div className="article-creator mt-3 mt-sm-3 mt-md-0">
          <img
            src={articlesPersonImage}
            alt="img"
            className="article-creator-image"
          />
          <div className="article-creator-section">
            <h3 className="article-creator-name">Md. Shafiqur Rahman Refat</h3>
            <h3 className="blog-article-date">25 Sept,2022</h3>
          </div>
        </div>
        <div className="time-and-view d-flex">
          <div className="blog-items-reading-time">
            <span className="time-and-view-color">
              <BiTimeFive />
            </span>{" "}
            6 min
          </div>
          <div className="blog-items-view">
            <span className="time-and-view-color">
              <AiOutlineEye />
            </span>{" "}
            1234
          </div>
        </div>
        <div className="blog-details-banner-image">
          <img
            src={blogDetailsBannerImage}
            alt="banner-img"
            className="img-fluid"
          />
        </div>
        <div className="blog-details-description">
          <p>
            Gather and evaluate user requirements in collaboration with product
            managers and engineers Illustrate design ideas using storyboards,
            process flows and sitemaps Design graphic user interface elements,
            like menus, tabs and widgets Build page navigation buttons and
            search fields Develop UI mockups and prototypes that clearly
            illustrate how sites function and look like Create original graphic
            designs (e.g. images, sketches and tables) Prepare and present rough
            drafts to internal teams and key stakeholders Identify and
            troubleshoot UX problems (e.g. responsiveness) Conduct layout
            adjustments based on user feedback Adhere to style standards on
            fonts, colors and image
          </p>
          <p>
            Gather and evaluate user requirements in collaboration with product
            managers and engineers Illustrate design ideas using storyboards,
            process flows and sitemaps Design graphic user interface elements,
            like menus, tabs and widgets Build page navigation buttons and
            search fields Develop UI mockups and prototypes that clearly
            illustrate how sites function and look like Create original graphic
            designs (e.g. images, sketches and tables) Prepare and present rough
            drafts to internal teams and key stakeholders Identify and
            troubleshoot UX problems (e.g. responsiveness) Conduct layout
            adjustments based on user feedback Adhere to style standards on
            fonts, colors and image
          </p>
        </div>
      </Container>
    </Container>
  );
};

export default BlogDetails;
